/** The routes of the pages in `src/app/[locale]`, relative to the locale, with Next.js's dynamic segment names. */
export const pageRouteTemplates: readonly string[] = [
  "",
  "1",
  "admin",
  "admin/courses",
  "admin/courses/new",
  "admin/help-chats",
  "admin/help-chats/[chatId]",
  "admin/hint-generation-failures",
  "admin/hint-generation-failures/[failureId]",
  "admin/organizations",
  "admin/organizations/[organizationId]",
  "admin/organizations/[organizationId]/edit",
  "admin/organizations/[organizationId]/groups",
  "admin/organizations/[organizationId]/groups/[groupId]",
  "admin/organizations/[organizationId]/groups/[groupId]/edit",
  "admin/organizations/[organizationId]/members",
  "admin/organizations/new",
  "admin/profiles",
  "admin/readability-experiment",
  "admin/repositories",
  "admin/repositories/[repositoryId]/members",
  "agent-challenges/authorize",
  "agent-challenges/setup",
  "auth/signin",
  "contact/form",
  "contests",
  "contests/[contestId]",
  "contests/[contestId]/problems",
  "contests/[contestId]/problems/[problemId]",
  "contests/[contestId]/standings",
  "courses",
  "courses/[courseId]",
  "courses/[courseId]/edit",
  "courses/[courseId]/lecture-schedule",
  "courses/[courseId]/monitor",
  "courses/[courseId]/monitor/chats/[chatId]",
  "guest",
  "help/[[...slug]]",
  "help/admin/[[...slug]]",
  "materials/[materialId]",
  "materials/[materialId]/edit",
  "materials/[materialId]/edit/problems/[problemId]",
  "materials/[materialId]/edit/problems/new",
  "materials/[materialId]/problems/[problemId]",
  "materials/[materialId]/problems/[problemId]/leaderboard",
  "materials/[materialId]/problems/[problemId]/leaderboard/[lockId]",
  "materials/[materialId]/review",
  "materials/[materialId]/survey-management",
  "organizations/[organizationId]",
  "organizations/[organizationId]/chats",
  "organizations/[organizationId]/chats/[chatId]",
  "organizations/[organizationId]/chats/monitor",
  "organizations/[organizationId]/courses",
  "organizations/[organizationId]/courses/new",
  "organizations/[organizationId]/groups",
  "organizations/[organizationId]/groups/[groupId]",
  "organizations/[organizationId]/groups/[groupId]/courses",
  "organizations/[organizationId]/groups/[groupId]/edit",
  "organizations/[organizationId]/groups/[groupId]/members",
  "organizations/[organizationId]/groups/new",
  "organizations/[organizationId]/join",
  "organizations/[organizationId]/members",
  "organizations/[organizationId]/repositories",
  "organizations/[organizationId]/repositories/[repositoryId]/members",
  "organizations/[organizationId]/settings",
  "playgrounds/backlog",
  "playgrounds/backlog/tickets/[number]",
  "playgrounds/bbs",
  "playgrounds/bbs/channels/[channelSlug]",
  "playgrounds/hosting",
  "portfolio/[portfolioId]",
  "portfolio/mine",
  "problems",
  "problems/[problemId]",
  "question-submissions",
  "question-submissions/[questionSubmissionId]",
  "repositories",
  "settings",
  "submissions",
  "submissions/[submissionId]",
  "turtle-graphics-tracing-assignments/[assignmentId]",
  "user-profiles"
];
